<div class="file-list-element flex flex-start-center">
  <a
    [attr.href]="blobUrl | trustedUrl"
    [attr.title]="file.name"
    class="file-name"
    color="primary"
    data-test-id="file-upload-element-fileName"
    mat-button
    target="_blank"
    type="button"
  >
    {{ file.name }}
  </a>
  <button
    [disableRipple]="true"
    (click)="emitFileRemoval()"
    class="color-on-hover remove-file-btn"
    color="warn"
    data-test-id="file-upload-element-removeFileBtn"
    mat-icon-button
    type="button"
  >
    <mat-icon class="no-transition" svgIcon="close_tiny"></mat-icon>
  </button>
</div>
